import { render } from "./Overlay.vue?vue&type=template&id=77f22ac8&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=77f22ac8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f22ac8"]])

export default __exports__